export const HOST = "http://217.144.106.32:6565";
// export const HOST = "http://192.168.100.9:6565";
export const ERROR_COLOR = "#d32f2f";
export const GREEN_PRIMRY = "#1abb9c";
// export const BLUE_PRIMARY = "#3f48cc";
export const BLUE_PRIMARY = "#5962dc";
export const ORANGE_COLOR = "#ed6c02";
export const BLUE_COLOR = "#0288d1";
export const SILVER_TABLE_COLOR = "rgba(0, 0, 0, 0.04)";
export const BLACK = "#000";
export const WHITE = "#fff";
export const DARK_SIDEBAR = "rgb(52, 73, 94)";

export const pageSize = 5;
export const usersPageSize = 100;
export const projectsPageSize = 12;
export const counterTypesPageSize = 10;
export const countersPageSize = 10;
export const consumptionRecordsPageSize = 20;
export const eventRecordsPageSize = 5;

export const cities = [
  { title: "" },
  { title: "سراسر کشور" },
  { title: "تهران" },
  { title: "مشهد" },
  { title: "شیراز" },
  { title: "قم" },
  { title: "اراک" },
  { title: "اردبیل" },
  { title: "ارومیه" },
  { title: "اصفهان" },
  { title: "اهواز" },
  { title: "ایلام" },
  { title: "بجنورد" },
  { title: "بندرعباس" },
  { title: "بوشهر" },
  { title: "بیرجند" },
  { title: "تبریز" },
  { title: "خرم آباد" },
  { title: "رشت" },
  { title: "زاهدان" },
  { title: "زنجان" },
  { title: "ساری" },
  { title: "سمنان" },
  { title: "سنندج" },
  { title: "شهرکرد" },
  { title: "قزوین" },
  { title: "کرج" },
  { title: "کرمان" },
  { title: "کرمانشاه" },
  { title: "گرگان" },
  { title: "همدان" },
  { title: "یاسوج" },
  { title: "یزد" },
];

export const COLORS = [
  "#DB7734",
  "#97DB34",
  "#3498DB",
  "#DB3498",
  "#DB3455",
  "#6AD5E5",
  "#008080", // teal
  "#2E8B57", // sea green
  "#DAA520", // golden rod
  "#B22222", // firebrick
  "#4682B4", // steel blue
  "#6495ED", //corn flower blue
  "#8A2BE2", //blue violet
  "#7B68EE", //medium slate blue
  "#CD853F", // peru
  "#BC8F8F", // rosy brown
  "#808080", // gray / grey
];
